import { render, staticRenderFns } from "./QueryProfile.vue?vue&type=template&id=2f7a488f&"
import script from "./QueryProfile.vue?vue&type=script&lang=js&"
export * from "./QueryProfile.vue?vue&type=script&lang=js&"
import style0 from "./QueryProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QueryProfile.vue"
export default component.exports